import type {Color} from "@cm/graph-v3"
import {z} from "zod/v4-mini"

export interface ColorStop {
    position: number
    color: Color
    alpha: number
}

export const interpolationTypeSchema = z.enum(["LINEAR", "EASE", "CARDINAL", "B_SPLINE", "CONSTANT"])
export type InterpolationType = z.infer<typeof interpolationTypeSchema>
